import React, {useEffect, useState} from 'react';

import './styles.scss';
import {connect} from 'react-redux';
import {
  addToGlobalStyles,
  addToWizard,
  setGlobalStyles,
  setStrings,
  setWizard,
  setStringsDefault,
  setBuDefaultFunctionalities,
  setIsLanguageSelected,
  setLanguage,
  setLanguageOptions,
} from '../../store/actions';
import {compose} from 'redux';
import RegisterHeader from '../../components/headers/register-header';
import {Column, Row} from '../../components/layout';
import Header1 from '../../components/headers/header1';
import {functionalitiesAliasMap, strings} from '../../util/strings';
import * as fonts from '../../util/fonts';
import colors, {pageBackgrounds} from '../../util/colors';
import {getDataFromCMD, uriGetFunctionalities} from '../../api/endpoints';
import {has18Years, updateStringFeatureWithLabels} from '../../util/utility';
import AppSpinner from '../../components/app-spinner';
import {withRouter} from 'react-router';
import {get, post} from '../../api/api';
import {
  AppForm,
  AppFormRadioField,
  AppFormSubmitButton,
} from '../../components/forms';
import * as Yup from 'yup';
import BeforeContinueCMD from './before-continue/BeforeContinueCMD';
import CommunicationsCMD from './communications-cmd/CommunicationsCMD';
import AccountDataCMD from './account-data-cmd/AccountDataCMD';
import {ITenant} from '../../App';

export interface RegisterPageCMDProps {
  wizard: any;
  globalStyles: any;
  addToWizard(value: any): void;
  addToGlobalStyles(value: any): void;
  setGlobalStyles(value: any): void;
  setStrings(value: any): void;
  setStringsDefault(value: any): void;
  setBuDefaultFunctionalities(value: any): void;
  labels: typeof strings.pt.registoCMD;
  labelsRegister: any;
  labelsMessages: typeof strings.pt.messages;
  history?: any;
  reduxStrings: any;
  user: any;
  isLanguageSelected: boolean;
  language: string;
  setLanguage(value: any): void;
  setIsLanguageSelected(value: any): void;
  setLanguageOptions(value: any): void;
  languageOptions: any;
  tenant: ITenant;
}

const RegisterPageCMD = ({
  wizard,
  globalStyles,
  addToWizard,
  addToGlobalStyles,
  setGlobalStyles,
  setStrings,
  setStringsDefault,
  setBuDefaultFunctionalities,
  labels,
  labelsMessages,
  labelsRegister,
  history,
  reduxStrings,
  user,
  isLanguageSelected,
  language,
  setLanguage,
  setIsLanguageSelected,
  setLanguageOptions,
  languageOptions,
  tenant,
}: RegisterPageCMDProps) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingAttributes, setIsLoadingAttributes] = useState(true);
  const [isMultiLanguage, setIsMultiLanguage] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState(
    window.location.search?.split('=')[1],
  );
  const [showCommunications, setShowCommunications] = useState(false);
  const [showAccountData, setShowAccountData] = useState(false);
  const [userDob, setUserDob] = useState('');
  const [userNif, setUserNif] = useState('');

  const featureName = 'RedirectPageCMD';

  const verifyCancelledRegisterCMD = () => {
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.substring(1));
    const error = params.get('error') || '';
    if (error) {
      sendMessageToAppInScript('-1', '-1');
      history.push('/');
    }
  };

  useEffect(() => {
    verifyCancelledRegisterCMD();
    setCurrentLanguage(window.location.search?.split('=')[1]);
    setLanguage(
      window.location.search?.split('=')[1] || labelsMessages?.default_language,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (tenant) {
      getLanguage();
      requestAuthentication();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenant?.alias]);

  useEffect(() => {
    if (userDob && userNif) {
      sendMessageToAppInScript(userNif, userDob);
    }
  }, [userNif, userDob]);

  const sendMessageToAppInScript = (userNif: any, userDob: any) => {
    // Check if the script function exists before calling it
    if ((window as any)?.sendMessageToApp) {
      (window as any).sendMessageToApp(userNif, userDob);
    }
  };

  const requestAuthentication = async () => {
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.substring(1));
    const localStorageUser = JSON.parse(
      localStorage?.getItem('user') as string,
    );
    const accessToken =
      params.get('access_token') || localStorageUser?.access_token;
    const birthdate = 'http://interop.gov.pt/MDC/Cidadao/DataNascimento';
    const nif = 'http://interop.gov.pt/MDC/Cidadao/NIF';

    const body = JSON.stringify({
      token: accessToken,
      attributesName: [birthdate, nif],
    });
    try {
      const response: any = await post(
        getDataFromCMD(),
        body,
        false,
        featureName,
      );
      if (response) {
        response?.data?.items?.forEach((item: any) => {
          if (item.name === birthdate) {
            setUserDob(item.value);
          } else if (item.name === nif) {
            setUserNif(item.value);
          }
        });
      }
    } catch (error: any) {
      console.error('There was an error fetching data from CMD:', error);
    } finally {
      setIsLoadingAttributes(false);
    }
  };

  const checkDob = async () => {
    const [day, month, year] = userDob?.split('-').map(Number);

    // Months in JavaScript Date are 0-indexed, so subtract 1 from the month.
    const dateObject = new Date(year, month - 1, day);

    if (!has18Years(dateObject)) {
      history.push('/utilizador-menor');
    }
  };

  const getLanguage = async () => {
    addToGlobalStyles({
      background: pageBackgrounds.registerPage,
    });
    getLanguageOptions();
    getLabels(language);
  };

  const getLanguageOptions = async () => {
    const languageOptions = tenant?.languages?.map((lng: any) => lng.alias);
    setLanguageOptions(languageOptions);
  };

  const getLabels = async (language: string, checkUnderage = false) => {
    const newDefaultFunctionalities = await get(
      uriGetFunctionalities('ADV'),
      false,
      0,
      featureName,
    ).then((response: any) => ({
      funcionalidade: response?.data?.items || response,
    }));

    let stringsToState = {...strings, ...reduxStrings};

    if (!!newDefaultFunctionalities) {
      newDefaultFunctionalities.funcionalidade.length > 0 &&
        newDefaultFunctionalities.funcionalidade.find(
          (funct: any) =>
            funct?.featureTemplateAlias ===
              functionalitiesAliasMap.multiLanguage && funct?.isVisible,
        ) &&
        setIsMultiLanguage(true);
      setBuDefaultFunctionalities(newDefaultFunctionalities);
      stringsToState = updateStringFeatureWithLabels(
        stringsToState,
        newDefaultFunctionalities.funcionalidade,
      );
      setStringsDefault(stringsToState);
      setStrings(stringsToState);
    } else {
      setStringsDefault(strings);
      setStrings(strings);
    }
    setIsLoading(false);
    checkUnderage && checkDob();
  };

  const renderLanguageSelector = () => {
    return (
      <AppForm
        validationSchema={validationSchema}
        initialValues={{
          selectedLanguage: language,
        }}
        onSubmit={(values) => {
          setLanguage(values.selectedLanguage);
          history.push({
            pathname: window.location.pathname,
            search: `?language=${values.selectedLanguage}`,
            hash: window.location.hash,
          });
          setIsLoading(true);
          setCurrentLanguage(values.selectedLanguage);
          getLabels(values.selectedLanguage, true);

          setIsLanguageSelected(true);
        }}
        className="register-language-selector-form">
        <AppFormRadioField
          className="register-language-selector-radio-select"
          name="selectedLanguage"
          options={renderLanguageOptions(languageOptions)}
        />
        <div>
          <p
            className="register-language-selector-info"
            style={{
              ...fonts.M,
              color: colors.black,
            }}>
            {labels?.registoCMD_multi_language_info}
          </p>
          <AppFormSubmitButton
            title={labels?.registoCMD_contactActivation_buttonText}
            type="submit"
          />
        </div>
      </AppForm>
    );
  };

  const renderLanguageOptions = (languageOptions: any) => {
    const result = languageOptions ? [...languageOptions] : [];

    const ptLangIndex = result.findIndex(
      (el: any) => el === labelsMessages?.default_language,
    );
    if (ptLangIndex !== -1) {
      const ptLang = result.splice(ptLangIndex, 1);
      result.unshift(ptLang[0]);
    }

    return result.map((option: any) => ({
      label: labelsRegister?.[option],
      value: option,
    }));
  };

  if (showCommunications && !!!wizard.communications) {
    return (
      <CommunicationsCMD
        setShowAccountData={setShowAccountData}
        setShowCommunications={setShowCommunications}
      />
    );
  }

  const validationSchema = Yup.object().shape({});

  const beforeContinueOnSubmit = (values: any) => {
    addToWizard({
      insuranceValidation: {...values, nif: userNif, dateOfBirth: userDob},
    });
    setShowCommunications(true);
  };

  return (
    <Column className="register-main-column">
      <RegisterHeader />
      <Column className="register-container">
        <Row className="register-header-row">
          {!(isLoading || isLoadingAttributes) && (
            <Header1
              style={{...fonts.XL, ...fonts.Bold, color: colors.black}}
              className="register-welcome-header">
              {!isLanguageSelected
                ? labels?.registoCMD_multi_language_pageTitle
                : showAccountData
                  ? labels?.registoCMD_pageTitle
                  : labels?.registoCMD_before_continue_cmd_title}
            </Header1>
          )}
        </Row>

        {isLoading || isLoadingAttributes ? (
          <AppSpinner
            type="grey"
            style={{
              width: 'fit-content',
              justifyContent: 'center',
              alignSelf: 'center',
            }}></AppSpinner>
        ) : (
          <>
            {isMultiLanguage && !isLanguageSelected ? (
              renderLanguageSelector()
            ) : showAccountData ? (
              <AccountDataCMD language={currentLanguage} />
            ) : (
              <BeforeContinueCMD onSubmit={beforeContinueOnSubmit} />
            )}
          </>
        )}
      </Column>
    </Column>
  );
};

const mapStateToProps = ({
  wizard,
  strings,
  globalStyles,
  stringsDefault,
  user,
  language,
  isLanguageSelected,
  languageOptions,
  tenant,
}: any) => ({
  wizard: wizard.value,
  labels: stringsDefault.value.pt.registoCMD,
  labelsRegister: stringsDefault.value.pt.register,
  labelsMessages: stringsDefault.value.pt.messages,
  globalStyles: globalStyles.value,
  reduxStrings: stringsDefault.value,
  user: user.value,
  language: language.value,
  isLanguageSelected: isLanguageSelected.value,
  languageOptions: languageOptions.value,
  tenant: tenant.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  setGlobalStyles: (value: any) => dispatch(setGlobalStyles(value)),
  setStrings: (value: any) => dispatch(setStrings(value)),
  setStringsDefault: (value: any) => dispatch(setStringsDefault(value)),
  setBuDefaultFunctionalities: (value: any) =>
    dispatch(setBuDefaultFunctionalities(value)),
  setIsLanguageSelected: (value: any) => dispatch(setIsLanguageSelected(value)),
  setLanguage: (value: any) => dispatch(setLanguage(value)),
  setLanguageOptions: (value: any) => dispatch(setLanguageOptions(value)),
});

export default compose(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(RegisterPageCMD)),
);
